import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { RepositorioService } from '../../core/repositorio.service';
import { AngularFireStorage } from 'angularfire2/storage';
import { MatSnackBar } from '@angular/material';

//UPLOAD MULTI
import * as _ from 'lodash';
import { ArchivoCinco } from '../../interfaces/archivo-cinco';

@Component({
  selector: 'app-repositorio',
  templateUrl: './repositorio.component.html',
  styleUrls: ['./repositorio.component.css']
})
export class RepositorioComponent implements OnInit {
  panelOpenState: boolean = false;

  loading = false;

  listaArchivos: ArchivoCinco;

  // carpetas = [
  //   {
  //     nombre: 'Fotos',
  //     actualizado: new Date('3/28/18'),
  //   },
  //   {
  //     nombre: 'Archivos',
  //     actualizado: new Date('3/28/18'),
  //   },
  //   {
  //     nombre: 'Repos',
  //     actualizado: new Date('3/28/18'),
  //   }
  // ];
  // archivos = [
  //   {
  //     nombre: 'Foto1.jpg',
  //     actualizado: new Date('3/28/18'),
  //   },
  //   {
  //     nombre: 'Foto2.jpg',
  //     actualizado: new Date('3/28/18'),
  //   }
  // ];

  carpetas: any;
  mostrarVisibles = true;


  constructor(private authService: AuthService, public rs: RepositorioService, private storage: AngularFireStorage,  public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.carpetas = this.rs.getCarpetasVisibles();
  }
  

  cargar(event: FileList, arreglo: Array<any>, idCarpeta: string){
    this.loading = true;

    let archivos = event;
    let archivosIndex = _.range(archivos.length)
    _.each(archivosIndex, (index) => {
      this.listaArchivos = new ArchivoCinco(archivos[index]);
      this.rs.cargar(this.listaArchivos, arreglo, idCarpeta);
    });

    setTimeout(() => {
      this.snackBar.open('Los archivos han sido cargados correctamente.', 'CERRAR', {
        duration: 4000
      });
      this.loading = false;
    }, 3000);



  }

  eliminarCarpeta(carpeta: any) {

    carpeta.archivos.forEach(archivo => {
      this.storage.ref(archivo.path).delete();
    });

    this.rs.eliminar(carpeta.id);

    this.snackBar.open('La carpeta ha sido eliminada correctamente.', 'CERRAR', {
      duration: 4000
    });
  }

  eliminarArchivo(arreglo: Array<any>, path:string, carpetaId:string ){

    arreglo = arreglo.filter(item => item.path !== path)

    this.storage.ref(path).delete();

    this.rs.actualizar(carpetaId,
      { archivos: arreglo }
    );

    this.snackBar.open('El archivo ha sido eliminado correctamente.', 'CERRAR', {
      duration: 4000
    });

  }

  toggleEncuestas(visibles: boolean) {
    // console.log(visibles);
    if (visibles) {
      this.carpetas = this.rs.getCarpetasVisibles();
      this.mostrarVisibles = true;

    }
    if (!visibles) {
      this.carpetas = this.rs.getCarpetasOcultas();
      this.mostrarVisibles = false;
    }
  }

  toggleOculto(oculto: boolean, id: string) {
    // console.log(oculto);
    if (oculto) {
      this.rs.actualizar(id,
        {
          oculto: true,
        }
      );
    } if(!oculto) {
      this.rs.actualizar(id,
        {
          oculto: false,
        }
      );
    }
  }
  // eliminarFoto(arreglo: Array<any>, path: string) {
  //   console.log(arreglo)

  //   arreglo = arreglo.filter(item => item.path !== path);

  //   this.storage.ref(path).delete();

  //   this.ns.actualizar(this.noticiaId,
  //     { fotos: arreglo }
  //   );

  // }

}



// WEBPACK FOOTER //
// ./src/app/modulos/repositorio/repositorio.component.ts